import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
// Rows only exist for document types a tenant has configured before, so a missing row means
// every flag is still on its default.
export const useGetDocumentTypeSettings = (enabled = true) => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.DocumentTypeSettings], () => api.base
        .get(`${config.appUrls.documents}/api/DocumentTypeSetting`)
        .then(res => res.data), {
        enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
